<template>
  <vjs-modal v-bind="$options.propsData"
             :name="name"
             :title="modal_title"
             :icon="icon">
    <p style="font-weight: bold">
      Banner artwork criteria:
    </p>
    <ul>
      <li>Image aspect ratio of  1:1.5</li>
      <li>PNG or JPG/JPEG format (with .png, .jpg, or .jpeg file extension)</li>
      <li>RGB colour space</li>
    </ul>
    <template slot="body-controls">
      <button class="btn btn-ss-cancel w-50" @click="complete">
        Close
      </button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModalMixin from 'VueModals/VjsModalMixin';

export default {
  mixins: [VjsModalMixin],
  props: {
    name: {
      type: String,
      required: false,
      default: 'banner-feed-suitability',
    },
    title: {
      type: String,
      required: false,
      default: null,
    },
    icon: {
      type: String,
      required: false,
      default: 'la la-info-circle',
    },
  },
  data() {
    return {
      modal_title: this.title ?? `${this.getFeedLabel(true)} Banner Artwork Suitability`,
    };
  },
};
</script>
